module.exports = __webpack_public_path__ + "static/media/LandingReport.b68a480e.svg";